import { useQuery } from '@tanstack/react-query';
import { FinancialWidgetsService } from '@/services/financial-widgets-service';
import { useGetBackendUrl } from './use-get-backend-url';

export function useFinancialWidgets() {
  const backendUrl = useGetBackendUrl();
  const service = new FinancialWidgetsService(backendUrl);

  return {
    useTotalAssetValue: () =>
      useQuery({
        queryKey: ['financial-widgets', 'total-asset-value'],
        queryFn: () => service.getTotalAssetValue(),
        staleTime: 5 * 60 * 1000, // 5 minutes
      }),

    useAssetValueTrend: (months: number = 12) =>
      useQuery({
        queryKey: ['financial-widgets', 'asset-value-trend', months],
        queryFn: () => service.getAssetValueTrend(months),
        staleTime: 5 * 60 * 1000,
      }),

    useRoiMetrics: () =>
      useQuery({
        queryKey: ['financial-widgets', 'roi-metrics'],
        queryFn: () => service.getRoiMetrics(),
        staleTime: 5 * 60 * 1000,
      }),

    useCostBreakdown: () =>
      useQuery({
        queryKey: ['financial-widgets', 'cost-breakdown'],
        queryFn: () => service.getCostBreakdown(),
        staleTime: 5 * 60 * 1000,
      }),

    useDepreciationByCategory: () =>
      useQuery({
        queryKey: ['financial-widgets', 'depreciation-by-category'],
        queryFn: () => service.getDepreciationByCategory(),
        staleTime: 5 * 60 * 1000,
      }),

    useAssetValueByLocation: () =>
      useQuery({
        queryKey: ['financial-widgets', 'asset-value-by-location'],
        queryFn: () => service.getAssetValueByLocation(),
        staleTime: 5 * 60 * 1000,
      }),

    useTopAssetsByValue: (limit: number = 10) =>
      useQuery({
        queryKey: ['financial-widgets', 'top-assets-by-value', limit],
        queryFn: () => service.getTopAssetsByValue(limit),
        staleTime: 5 * 60 * 1000,
      }),

    useWarrantyStatus: () =>
      useQuery({
        queryKey: ['financial-widgets', 'warranty-status'],
        queryFn: () => service.getWarrantyStatus(),
        staleTime: 5 * 60 * 1000,
      }),

    useFinancialSummary: () =>
      useQuery({
        queryKey: ['financial-widgets', 'financial-summary'],
        queryFn: () => service.getFinancialSummary(),
        staleTime: 5 * 60 * 1000,
      }),
  };
}
